import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDiagnostic } from "@/context/DiagnosticContext";
import { SphereMark } from "@/components/brand/SphereMark";
import { Check } from "lucide-react";

const STEPS = [
  "Evaluating Strategy, Systems & People",
  "Profiling your primary archetype",
  "Identifying your three priorities",
  "Composing your interpretation",
];

export default function Analysing() {
  const navigate = useNavigate();
  const { session } = useDiagnostic();
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (!session.respondentId) {
      navigate("/pathway");
      return;
    }
    const stepTimers = STEPS.map((_, i) => setTimeout(() => setStep(i + 1), 700 * (i + 1)));
    const done = setTimeout(() => navigate(`/results/${session.respondentId}`), 3600);
    return () => {
      stepTimers.forEach(clearTimeout);
      clearTimeout(done);
    };
  }, [session.respondentId, navigate]);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-black px-6 text-center"
      data-testid="analysis-transition-container"
    >
      {/* Branded animation area — three glossy spheres with pulse ring */}
      <div className="relative flex h-40 w-40 items-center justify-center">
        <span className="tw-pulse-ring absolute inset-0 rounded-full border border-[#1408F7]" />
        <span
          className="tw-pulse-ring absolute inset-0 rounded-full border border-[#1408F7]"
          style={{ animationDelay: "1.2s" }}
        />
        <SphereMark size={26} className="tw-float" />
      </div>

      <h1 className="mt-14 text-3xl font-semibold tracking-tight text-white sm:text-4xl">
        We&apos;re analysing your marketing.
      </h1>
      <p
        className="mt-4 max-w-md text-base text-neutral-400"
        data-testid="analysis-status-text"
      >
        {STEPS[Math.min(step, STEPS.length - 1)]}…
      </p>

      <div className="mt-12 w-full max-w-sm space-y-3 text-left">
        {STEPS.map((s, i) => {
          const active = i < step;
          return (
            <div key={s} className="flex items-center gap-3 text-sm">
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                  active ? "border-[#1408F7] bg-[#1408F7]" : "border-white/20"
                }`}
              >
                {active && <Check className="h-3 w-3 text-white" />}
              </span>
              <span className={active ? "text-white" : "text-neutral-500"}>{s}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
